<template>
    <div
        v-if="!isConditional"
        ref="textElement"
        :class="customClass"
        v-html="textOutput"
    ></div>

    <zoe-atom-conditional-text
        v-else
        :class="customClass"
        :text="text"
        :path="path"
    />
</template>

<script setup>
import { ref, defineProps, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import ZoeAtomConditionalText from '../../conditional-text/v1.0.0/zoe-atom-conditional-text.vue';
import { get } from '../../../../../../resources/frontend/js/mixins/get-page-data';
import replaceVariables from '../../../../mixins/utils/replace-variables.js';
import searchForAnchors from '@mixins/utils/search-for-anchors';
import { useDialogStore } from '@stores/dialog';
import { storeToRefs } from 'pinia';

const props = defineProps({
    path: {
        type: String,
        required: false,
        default: '',
    },
    item: {
        type: [Object, String],
        required: false,
        default: null,
    },
    customClass: {
        type: String,
        required: false,
        default: '',
    },
});

const store = useStore();
const textElement = ref(null);
let text = ref('');

if (props.path) {
    text.value = get(props.path);
} else if (props.item) {
    text.value = props.item;
}

onMounted(() => {
    if (isConditional.value) return;

    replaceDialogs();
    searchForAnchors(textElement.value.querySelectorAll('.anchor'));
});

const replaceDialogs = () => {
    for (const dialog of textElement.value.querySelectorAll('[data-dialog]')) {
        dialog.addEventListener('click', () => {
            const dialogId = dialog.getAttribute('data-dialog');
            store.commit('dialog/show', dialogId);

            const dialogStore = useDialogStore();
            const { active } = storeToRefs(dialogStore);
            active.value = dialogId;
        });
    }
};

const isConditional = computed(() => {
    return !!text.value.useConditionalTexts;
});

const textOutput = computed(() => {
    if (typeof text.value === 'object') {
        return replaceVariables(text.value.text);
    }

    return replaceVariables(text.value);
});
</script>

<style lang="scss">
@import "zoe-atom-text";
</style>
